import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurvedGasVent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 70,
	viewBox: "0 0 30.0 70.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 70.0 L 0.0 15.0 A 15.0 15.0 0.0 1 1 30.0 15.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgCurvedGasVent;
